module.exports = function getResource(label) {
    let resources = {
        helpful: 'Helpful?',
        thanks: 'Thanks for your feedback'
    };
    return resources[label];
};
